// tslint:disable:max-line-length

import React from 'react';

export const ActionUndo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M9,2C5.1,2,2.5,5.1,2.5,9v1L0,10l4,4l4-4H5.5V9c0-2.8,2.7-5,5.5-5c2.4,0,4.4,1.7,4.9,4C15.4,4.6,12.5,2,9,2z" />
    </svg>
  );
};
